export default __webpack_public_path__ + "static/media/tamGiangLengthFrequencies.159779d7.png";